import type { Uuid } from "@/types"

export const UserLocalStorage = {
  storageKey: "iroh_services_current_user",
  setUserId(id: Uuid) {
    localStorage.setItem(this.storageKey, id)
  },
  getUserId(): Uuid | null {
    return localStorage.getItem(this.storageKey)
  },
  clearUserId(): void {
    localStorage.removeItem(this.storageKey)
  },
}
